import Vue from "vue";
import { Component } from "vue-property-decorator";
import ListItemNumberModel from "@/models/listItemNumberModel";
import { stringMaxLength } from "../../../../assets/validation/common";

@Component
export default class PersonRoleDialog extends Vue {
    validation = [stringMaxLength(this.$i18n, "", 128), (value: string) => !!value || this.$t("common.validationErrorRequired")];

    get showDialog(): boolean {
        return this.$store.direct.state.register.showPorsonRoleDialog;
    }

    get model(): ListItemNumberModel {
        return this.$store.direct.state.register.personRole;
    }

    async saveClick() {
        const valid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
        if (valid) {
            await this.$store.direct.dispatch.register.updatePersonRole();
        }
    }

    async backClick() {
        await this.$store.direct.dispatch.register.closePersonRoleDialog();
    }
}
